import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
const debounceTimers = new Map();
export const debounce = (callback, delay = 500)=>{
    clearTimeout(debounceTimers.get(callback));
    debounceTimers.set(callback, setTimeout(callback, delay));
};
export const getFormError = (invalidFields)=>{
    const errorMessages = {};
    invalidFields?.forEach((field)=>{
        const inputName = field.getAttribute('name');
        const statusId = field.getAttribute('aria-describedby')?.split(' ')[0];
        const validationMessage = statusId && field.closest('form')?.querySelector(`#${statusId}`)?.innerText;
        if (inputName && validationMessage) {
            errorMessages[validationMessage] ??= [];
            errorMessages[validationMessage].push(inputName);
        }
    });
    return Object.entries(errorMessages).map(([message, fields])=>`> ${message}: ${fields.join(', ')}`).join('\n');
};
export const getFormProduct = (input)=>{
    let product = 'Power_Gas';
    if (input.energyAnualConsumptionPlan === undefined) {
        product = 'Gas';
    } else if (input.gasAnualConsumptionPlan === undefined) {
        product = 'Power';
    }
    return product;
};
const getErrorMessage = (input, messages)=>{
    const { max, maxLength, min, minLength, step, validity } = input;
    if (validity) {
        switch(true){
            case validity.valid:
                return;
            case validity.patternMismatch:
                return messages?.pattern ?? 'Bitte überprüfen Sie das Format Ihrer Eingabe';
            case validity.rangeOverflow:
                return messages?.max ?? `Der Wert darf nicht größer als ${max} sein`;
            case validity.rangeUnderflow:
                return messages?.min ?? `Der Wert darf nicht kleiner als ${min} sein`;
            case validity.stepMismatch:
                return messages?.step ?? `Der Wert muss ein Vielfaches von ${step} sein`;
            case validity.tooLong:
                return messages?.maxLength ?? `Der Wert darf nicht länger als ${maxLength} Zeichen sein`;
            case validity.tooShort:
                return messages?.minLength ?? `Der Wert darf nicht kürzer als ${minLength} Zeichen sein`;
            case validity.valueMissing:
                return messages?.required ?? 'Hier fehlt eine Angabe';
            default:
                return messages?.invalid ?? 'Bitte überprüfen Sie Ihre Eingabe';
        }
    }
};
export const withValidation = (Component)=>({ messages, onBlur, onInput, onInvalid, statusLabel, statusType, ...props })=>{
        const [error, setError] = useState();
        const [isTouched, setIsTouched] = useState(false);
        const validate = (input)=>setError(getErrorMessage(input, messages));
        return /*#__PURE__*/ _jsx(Component, {
            ...props,
            onBlur: (event)=>{
                setIsTouched(true);
                validate(event.target);
                onBlur?.(event);
            },
            onInput: (event)=>{
                if (isTouched || error || event.target.type === 'checkbox') {
                    validate(event.target);
                }
                onInput?.(event);
            },
            onInvalid: (event)=>{
                event.preventDefault();
                validate(event.target);
                onInvalid?.(event);
            },
            statusLabel: error || statusLabel,
            statusType: error ? 'error' : statusType
        });
    };

//# sourceMappingURL=Form.helpers.js.map